var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"pagination"}},[_c('el-pagination',{attrs:{"background":"","layout":"sizes,prev, pager, next","page-sizes":_vm.pageSizes,"page-size":_vm.perSize,"total":_vm.totalSize,"current-page":_vm.currentPage},on:{"size-change":_vm.handleSizeChange,"current-change":_vm.handleCurrentChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }